import { Component, Input, OnInit } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';
import { User } from 'src/app/model/user';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'impersonate-icon',
  templateUrl: './impersonate-icon.component.html',
  styleUrls: ['./impersonate-icon.component.scss']
})
export class ImpersonateIconComponent implements OnInit {
  @Input()
  user?: User;

  constructor(
    private authService: AuthService,
    private modalService: ModalService
  ) {}

  ngOnInit(): void {}

  impersonateUser(): void {
    if (this.user != null && this.user.id != null) {
      const userName = StringHelper.join(
        [this.user.firstName, this.user.lastName],
        ' '
      );
      this.modalService.confirmDialog(
        `${userName} nabootsen`,
        `Bent u zeker dat u ${userName} wilt nabootsen?`,
        (b: boolean) => {
          if (b) {
            this.authService.impersonateUser({ id: this.user.id });
          }
        }
      );
    }
  }
}
